<template>
  <b-collapse
    id="cart-collapse"
    v-model="isCartVisible"
    class="header-cart"
    accordion="cart-collapse"
    @input="$emit('isCartVisible', $event)"
  >
    <loading-indicator v-if="!isCartEditDataLoaded && !isBasicCheckoutDataLoaded" />
    <div v-else class="cart-wrapper">
      <div class="d-flex justify-content-between cart-header">
        <span class="cart-text" v-text="$t('kosar') + ':'" />
        <span v-b-toggle.cart-collapse class="close-icon cursor-pointer" />
      </div>
      <div v-if="isCartHeaderExists && cartEditData && cartEditData.cartItemList.length !==0" class="row">
        <div class="col-12 col-lg-7">
          <div v-for="cartItem in cartEditData.cartItemList" :key="cartItem.id" class="shop-cart-card-wrapper">
            <product-card
              :product="cartItem"
              :is-cart-item="true"
              @removeFromCart="removeFromCart(cartItem)"
              @modifyProduct="modifyCartItem(cartItem)"
            />
          </div>
        </div>
        <div v-if="basicCheckoutData" class="col-12 col-lg-5">
          <payment-and-delivery />
          <hr class="price-line">
          <div class="shipping-wrapper">
            <div class="d-flex justify-content-between">
              <div v-t="'rendeluj_szallitas'" />
              <div>
                {{ basicCheckoutData.shippingPrice }}
                <span
                  v-if="basicCheckoutData.shippingPriceSecondary !== null"
                  class="ml-1"
                >
                  ({{ basicCheckoutData.shippingPriceSecondary }})
                </span>
              </div>
            </div>
            <div v-if="basicCheckoutData.isShippingHandlingFee" class="d-flex justify-content-between">
              <div>{{ basicCheckoutData.shippingHandlingFeeTitle }}</div>
              <div>{{ basicCheckoutData.shippingHandlingFee }}</div>
            </div>
          </div>
          <b-card>
            <div class="final-price-wrapper">
              <div
                v-if="basicCheckoutData.secondaryCurrencyExchangeRateFormatted !== null"
                class="text-right"
              >
                ({{ basicCheckoutData.secondaryCurrencyExchangeRateFormatted }})
              </div>
              <div class="d-flex justify-content-between align-items-end">
                <div v-t="'member_fizetendo_vegosszeg'" class="final-price-text" />
                <div class="final-price">
                  {{ basicCheckoutData.cartTotalSum }}
                  <span
                    v-if="basicCheckoutData.cartTotalSumSecondary !== null"
                    class="ml-1"
                  >
                    ({{ basicCheckoutData.cartTotalSumSecondary }})
                  </span>
                </div>
              </div>
            </div>
          </b-card>
          <div>
            <custom-input v-if="!cartEditData.userLoggedIn"
              v-model="emailInput"
              class="email-input"
              :title-name="$t('login_email')"
            />
          </div>
          <div v-if="!cartEditData.userLoggedIn" class="cart-btn-wrapper">
            <button
              v-t="'generic_save'"
              class="custom-button unfilled w-100 cart-btn"
              size="sm"
              :disabled="isCartSaveInProgress"
              @click="saveCartToEmail"
            />
          </div>
          <div class="cart-btn-wrapper">
            <router-link to="/checkout">
              <button
                v-t="'megrendelem'"
                class="custom-button filled w-100 cart-btn to-checkout"
              />
            </router-link>
          </div>
        </div>
      </div>
      <div v-else class="text-center">
        <div v-t="'kosarures'" class="empty-text" />
      </div>
    </div>
    <remove-item-from-cart-modal
      v-if="selectedCartItemForRemoveModal !== null"
      :cart-item="selectedCartItemForRemoveModal"
      @close="selectedCartItemForRemoveModal = null"
    />
    <cart-item-modal
      v-if="selectedCartItemForModal !== null"
      :cart-item="selectedCartItemForModal"
      @cartItemChanged="refreshSelectedCartItem"
      @close="selectedCartItemForModal = null"
      @removeFromCart="removeFromCart(selectedCartItemForModal)"
    />
  </b-collapse>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Axios from 'axios'
import { NOTY_TYPE } from '../../constant/builderConsts.js'
import { BCard, BCollapse, VBToggle } from 'bootstrap-vue'
import Vue from 'vue'
Vue.directive('b-toggle', VBToggle)

export default {
  name: 'Cart',
  components: {
    'loading-indicator': () => import(/* webpackChunkName: "LoadingIndicator" */ '../LoadingIndicator/LoadingIndicator.vue'),
    'product-card': () => import(/* webpackChunkName: "productCard" */ '../productCard/productCard.vue'),
    'custom-input': () => import(/* webpackChunkName: "customInput" */ '../customInput/customInput.vue'),
    'cart-item-modal': () => import(/* webpackChunkName: "cartItemModal" */ '../cart-item-modal/cart-item-modal.vue'),
    'remove-item-from-cart-modal': () => import(/* webpackChunkName: "removeItemFromCartModal" */ '../remove-item-from-cart-modal/remove-item-from-cart-modal.vue'),
    'payment-and-delivery': () => import(/* webpackChunkName: "paymentAndDelivery" */ '../paymentAndDelivery/paymentAndDelivery.vue'),
    'b-collapse': BCollapse,
    'b-card': BCard,
  },
  data() {
    return {
      /**
       * Országok listája a select mezőnek
       */
      countryList: null,
      /**
       * Kiválasztott ország
       */
      selectedCountry: null,
      /**
       * Kiválasztott szállítási mód
       */
      selectedShippingMethod: null,
      /**
       * Kiválasztott fizetési mód
       */
      selectedPaymentMethod: null,
      /**
       * kosár mentése emailhez input értéke
       */
      emailInput: '',
      /**
       * kosár mentése folyamatban van-e
       */
      isCartSaveInProgress: false,
      /**
       * modalnak átadott cartitem
       */
      selectedCartItemForModal: null,
      /**
       * törlés modal számára választott termék
       */
      selectedCartItemForRemoveModal: null,
      /**
       * le van-e nyitva a kosár
       */
      isCartVisible: false,
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'User/isLoggedIn',
      basicCheckoutData: 'Cart/getBasicCheckoutData',
      cartEditData: 'Cart/getCartEditData',
      isBasicCheckoutDataLoaded: 'Cart/getIsBasicCheckoutDataLoaded',
      isCartEditDataLoaded: 'Cart/getIsCartEditDataLoaded',
      cartPaymentShipmentData: 'Cart/getCartPaymentShipmentData',
      isCartPaymentShipmentDataLoaded: 'Cart/getIsCartPaymentShipmentDataLoaded',
      isCartHeaderExists: 'Cart/getIsCartHeaderExists',
    }),
  },
  created() {
    this.$store.dispatch('Cart/init')
    this.$root.$on('closeCart', this.closeCart)
  },
  destroyed() {
    this.$root.$off('closeCart', this.closeCart)
  },
  methods: {
    ...mapActions({
      loadCartPaymentShipmentData: 'Cart/loadCartPaymentShipmentData',
    }),
    /**
     * kosár becsukása, router afterEachből jön ez az event ami meghívja ezt a methodot
     */
    closeCart() {
      this.isCartVisible = false
    },
    /**
     * Kosárban lévő elem törlése
     *
     * @param cartItemForDelete
     */
    removeFromCart(cartItemForDelete) {
      this.selectedCartItemForRemoveModal = cartItemForDelete
      this.selectedCartItemForModal = null
    },
    /**
     * Kosárban lévő elem modosítása
     *
     * @param cartItemForModify
     */
    modifyCartItem(cartItemForModify) {
      this.$store.dispatch('Cart/getCartEditData', true)
        .then(() => {
          if (this.cartEditData === null) {
            this.$store.dispatch('Cart/resetDataLoadedFlags')
            this.$store.dispatch('Cart/getBasicCheckoutData', true)
            this.$store.dispatch('Cart/getCartAddressData', true)
          } else {
            // ellenőrizzük le, hogy biztos benne van-e (https://gitlab.builder.hu/builder/shop/-/issues/454)
            let isIdInCart = false
            if (this.cartEditData.cartItemList.length !== 0) {
              isIdInCart = this.cartEditData.cartItemList.some((cartItem) => cartItem.id === cartItemForModify.id)
            }
            if (isIdInCart === false) {
              this.$store.dispatch('Cart/getBasicCheckoutData', true)
              return
            }
            this.selectedCartItemForModal = cartItemForModify
            this.selectedCartItemForRemoveModal = null
          }
        })
    },
    /**
     * frissült a cartitem, azt is ujra frissitjuük amit a modalnak adunk
     */
    refreshSelectedCartItem() {
      if (this.selectedCartItemForModal && this.selectedCartItemForModal.id) {
        const selectedCartItemIndex = this.cartEditData.cartItemList.findIndex(cartItem => cartItem.id === this.selectedCartItemForModal.id)
        if (selectedCartItemIndex !== -1) {
          this.selectedCartItemForModal = this.cartEditData.cartItemList[selectedCartItemIndex]
        }
      }
    },
    /**
     * Email mező változására töltsük be az adatot a componensbe
     */
    emailInputChanged(inputValue) {
      this.emailInput = inputValue
    },
    /**
     * Kosár mentése
     */
    saveCartToEmail() {
      if (this.isCartSaveInProgress) {
        return
      }
      this.isCartSaveInProgress = true
      Axios.post('/Shop/api/saveCartToEmail', {
        email: this.emailInput,
      })
        .then(({ data }) => {
          if (data.success === false) {
            this.$root.$emit('notificationPush', data.msg, NOTY_TYPE.NOTY_ERROR)
          } else {
            this.$root.$emit('notificationPush', this.$t('modositas_mentve'), NOTY_TYPE.NOTY_SUCCESS)
          }
        })
        .catch((error) => {
          console.error('saveCartToEmail', error)
          this.$root.$emit('notificationPush', this.$t('sikertelen_muvelet'), NOTY_TYPE.NOTY_ERROR)
        })
        .finally(() => {
          this.isCartSaveInProgress = true
        })
    },
  },
}
</script>

<style lang="scss" src="./cart.scss" scoped />
